import { defineMessages } from 'react-intl'

const scope = `procurify.modules.expense.features.show-budget-info.SpendTrackerPresenter`

export default defineMessages({
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'No budgets to show',
  },
  emptyStateHeaderDeprecated: {
    id: `${scope}.emptyStateHeaderDeprecated`,
    defaultMessage: 'No spend to show',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      "This expense report isn't linked to a budget, so there's nothing to track yet.",
  },
})
